<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            @onShowForm="showForm = true"
            :clearable="clearable"
            @change="$emit('change', $event)"
            :showAdd="showAdd"
            :disabled="disabled"
        />
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'SysSelecWorkLoadConfirmStatus',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
        showForm: false
    }),
    computed: {
        ...mapState('auth', ['acesso'])
    },
    mounted(){
        
    },
    created() {
        this.getItems();
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        clearable: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        showAdd: {
            type: Boolean,
            default: false
        },
        filter: {
            type: Array,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        }
        
    },
    watch: {
        
        selected(val){
            this.$emit('update:model', val);
        },
        
        model(val){
            this.selected = val;
        },
    },
    methods: {
        ...mapActions('teacher', ['ActionFindWorkLoadConfirmationStatus']),
        
        async getItems() {

            this.loading = true

            await this.ActionFindWorkLoadConfirmationStatus()
                    .then((res) => {
                        
                        if(this.filter){
                            this.items = res.data.filter(i => this.filter.includes(i.id));
                        }else{
                            this.items = res.data;
                        }

                        this.selected = this.model;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },

    newItem(item){
            
            if(item){
                this.items.push(item);
                this.selected = item.id;
                this.showForm = false;
                this.$emit('new-item', item);
            }
        }
    },

    
    
}
</script>